import React from 'react';
import moment from 'moment';
import { Grid } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { getObjectTypeByKey, ObjectTypeType } from '@src/constants/objectType';
import { InspectedObjectDetailsDTO } from '@src/api/objectDetails/dto/InspectedObjectDetailsDTO';
import SailorLink from '@src/components/CustomCell/SailorLink';
import styles from './ObjectDetails.module.scss';
import ObjectDetailsField from './ObjectDetailsField';

type Props = {
  objectDetailsDTO: InspectedObjectDetailsDTO;
};

function LiftingObjectDetails({ objectDetailsDTO }: Props) {
  const { t } = useTranslation();

  const {
    equipmentId,
    site,
    impactFacility,
    description,
    buildingDescriptionEn,
    status,
    commissionDate,
    equipmentClass,
    manufacturer,
    category,
    model,
    building,
    serialNumber,
    inspectedObjectId,
    inspectionId,
    inspectionSummaryId,
  } = objectDetailsDTO.objectDetailsLifting;

  const inspectedObjectType: ObjectTypeType | undefined = getObjectTypeByKey(
    objectDetailsDTO.objectType
  );

  const { responsible, inspector, hseCode } =
    objectDetailsDTO.objectDetailsLifting.customPropertiesDTO;

  const labelPrefix = 'lifting.object.details';

  return (
    <Grid columns="equal" stackable className={styles.detailsContainer}>
      <Grid.Row className={styles.row}>
        <ObjectDetailsField
          field={t(`${labelPrefix}.equipment`)}
          value={equipmentId}
          icon="dolly"
        />
        <ObjectDetailsField field={t(`${labelPrefix}.site`)} value={site} />
        <ObjectDetailsField field={t(`${labelPrefix}.impactFacility`)} value={impactFacility} />
      </Grid.Row>

      <Grid.Row className={styles.row}>
        <ObjectDetailsField field={t(`${labelPrefix}.description`)} value={description} />
        <ObjectDetailsField
          field={t(`${labelPrefix}.buildingDescriptionEn`)}
          value={buildingDescriptionEn}
        />
        <ObjectDetailsField
          field={t(`${labelPrefix}.responsible`)}
          value={responsible}
          icon="user outline"
        />
      </Grid.Row>

      <Grid.Row className={styles.row}>
        <ObjectDetailsField field={t(`${labelPrefix}.status`)} value={status} />
        <ObjectDetailsField
          field={t(`${labelPrefix}.commissionDate`)}
          value={moment(commissionDate).format('DD-MMM-YYYY')}
          icon="calendar outline"
        />
        <ObjectDetailsField
          field={t(`${labelPrefix}.inspector`)}
          value={inspector}
          icon="user outline"
        />
      </Grid.Row>

      <Grid.Row className={styles.row}>
        <ObjectDetailsField field={t(`${labelPrefix}.equipmentClass`)} value={equipmentClass} />
        <ObjectDetailsField
          field={t(`${labelPrefix}.manufacturer`)}
          value={manufacturer}
          icon="factory"
        />
        <ObjectDetailsField field={t(`${labelPrefix}.hseCode`)} value={hseCode} />
      </Grid.Row>

      <Grid.Row className={styles.row}>
        <ObjectDetailsField field={t(`${labelPrefix}.category`)} value={category} />
        <ObjectDetailsField field={t(`${labelPrefix}.model`)} value={model} />
        <ObjectDetailsField
          field="SAILOR"
          value={
            inspectedObjectType && (
              <SailorLink
                objectType={inspectedObjectType}
                inspectionId={inspectionId}
                objectId={inspectedObjectId}
                inspectionSummaryId={inspectionSummaryId}
              />
            )
          }
        />
      </Grid.Row>

      <Grid.Row className={styles.rowNoBottomLine}>
        <ObjectDetailsField field={t(`${labelPrefix}.building`)} value={building} icon="building" />
        <ObjectDetailsField
          field={t(`${labelPrefix}.serialNumber`)}
          value={serialNumber}
          icon="barcode"
        />
        <ObjectDetailsField field="" value="" />
      </Grid.Row>
    </Grid>
  );
}

export default LiftingObjectDetails;
